module.exports = __webpack_public_path__ + "static/media/workload-arrow-right.bb0e6e1d.svg";